import { CustomActionButtonAspect } from '..'
import { SaveButtonVisibility } from '.'

export enum ButtonAlign {
  Left,
  Right,
}

export enum FormActionButtonType {
  Auto,
  Custom,
}

export interface AllFormButtons {
  id: string
  type: FormActionButtonType
  alignment: ButtonAlign
}

export interface AutoFormButtons {
  id: string
  alignment: ButtonAlign
  onClick: () => void
  label: React.ReactNode
  testId: string
  aspect: CustomActionButtonAspect
  disabled?: boolean
  visibility?: SaveButtonVisibility
}
